import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DXONgSwiftUiModule } from '@dxo/ng-swift-ui';
import { BenefitsSharedModule } from '@benefits/shared';
import Components from './components';
import FormComponents from './forms';
import { StepRouterService } from './services';

@NgModule({
  declarations: [FormComponents, Components],
  imports: [CommonModule, ReactiveFormsModule, DXONgSwiftUiModule, BenefitsSharedModule],
  exports: [FormComponents, Components],
  providers: [StepRouterService]
})
export class BenefitsSharedFormsModule {}
